import { styled } from '@grupoboticario/flora-react-system'
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'

const SCROLLBAR_SIZE = 10

const StyledScrollArea = styled(ScrollAreaPrimitive.Root, {
  overflow: 'hidden',
})

const StyledViewport = styled(ScrollAreaPrimitive.Viewport, {
  width: '100%',
  height: '100%',
  borderRadius: 'inherit',
})

const StyledScrollbar = styled(ScrollAreaPrimitive.Scrollbar, {
  display: 'flex',
  userSelect: 'none',
  touchAction: 'none',
  background: '$disabledBackground',
  borderRadius: SCROLLBAR_SIZE,
  transition: 'background 160ms ease-out',
  '&[data-orientation="vertical"]': {
    width: SCROLLBAR_SIZE,
  },
  '&[data-orientation="horizontal"]': {
    flexDirection: 'column',
    height: SCROLLBAR_SIZE,
  },
  variants: {
    variant: {
      alt: {
        background: '$disabledAltBackground',
      },
    },
  },
})

const StyledThumb = styled(ScrollAreaPrimitive.Thumb, {
  flex: 1,
  background: '$actionableDefault',
  borderRadius: SCROLLBAR_SIZE,
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    minWidth: 44,
    minHeight: 44,
  },
  variants: {
    variant: {
      alt: {
        background: '$actionableAlt',
      },
    },
  },
})

const StyledCorner = styled(ScrollAreaPrimitive.Corner, {
  background: '$disabledBackground',
  borderRadius: SCROLLBAR_SIZE,
  variants: {
    variant: {
      alt: {
        background: '$disabledAltBackground',
      },
    },
  },
})

export { StyledScrollArea, StyledViewport, StyledScrollbar, StyledThumb, StyledCorner }
